"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableRowSelector = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const column_1 = require("./column");
const row_selector_html_1 = __importDefault(require("./row-selector.html"));
const row_model_1 = require("./model/row-model");
let ItpDataTableRowSelector = class ItpDataTableRowSelector extends vue_1.default {
    col;
    row;
    get inputId() {
        return `rowSelector-${this.row.rowKey}`;
    }
    get className() {
        return [
            'itp-datatable__table-cell',
            'itp-datatable__table-row-selector',
            'position-relative',
            'align-middle'
        ];
    }
};
exports.ItpDataTableRowSelector = ItpDataTableRowSelector;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", column_1.ColumnDefinition)
], ItpDataTableRowSelector.prototype, "col", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", row_model_1.RowModel)
], ItpDataTableRowSelector.prototype, "row", void 0);
exports.ItpDataTableRowSelector = ItpDataTableRowSelector = __decorate([
    (0, vue_property_decorator_1.Component)({ template: row_selector_html_1.default })
], ItpDataTableRowSelector);
//# sourceMappingURL=row-selector.js.map